import { render } from "./sewageDeal.vue?vue&type=template&id=522dd4fa&scoped=true"
import script from "./sewageDeal.vue?vue&type=script&lang=js"
export * from "./sewageDeal.vue?vue&type=script&lang=js"

import "./sewageDeal.vue?vue&type=style&index=0&id=522dd4fa&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522dd4fa"]])

export default __exports__